import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
} from '@angular/core';
import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import PrivacyPolicyPreview from './PrivacyPolicyPreview';

@Component({
  selector: 'privacy-policy-preview-react',
  templateUrl: './privacy-policy-preview-react-container.component.html',
  styleUrls: ['./privacy-policy-preview-react-container.component.scss'],
  standalone: true,
})
export class PrivacyPolicyPreviewReactContainerComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  @Input() showHamburger: boolean = true;
  @Input() color: string;
  reactWrapperId: string;
  root: Root = null;

  constructor() {}

  ngOnInit() {
    this.reactWrapperId = 'privacy-policy-preview';
  }

  protected getRootDomNode() {
    const node = document.getElementById(this.reactWrapperId);
    return node;
  }

  ngOnDestroy(): void {
    this.root?.unmount();
  }

  ngOnChanges(): any {
    this.render();
  }

  protected render() {
    if (this.root) {
      this.root.render(
        React.createElement(PrivacyPolicyPreview, {
          showMenu: this.showHamburger,
          color: this.color,
        }),
      );
    }
  }

  ngAfterViewInit(): void {
    const node = document.getElementById(this.reactWrapperId);
    this.root = createRoot(node);
    this.render();
  }
}
